export type PositionStatus = "OPEN" | "CLOSED";

// Change from type to const object so it can be used as a value at runtime
export const PositionType = {
  ENTRY: "ENTRY",
  EXIT: "EXIT",
  PARTIAL_EXIT: "PARTIAL_EXIT",
  ADD_TO_POSITION: "ADD_TO_POSITION",
} as const;

export type PositionType = (typeof PositionType)[keyof typeof PositionType];

export interface Position {
  id: string;
  tradeId: number;
  type: PositionType;
  quantity: number;
  price: number;
  date: string;
  notes?: string;
  status: PositionStatus;
  createdAt: string;
  updatedAt: string;
  trade?: Trade;
  /**
   * Running cost basis for this position (average cost per unit for open positions, or cost basis at exit for EXIT positions)
   */
  costBasis?: number;
  /**
   * Realized P&L for this position (only for EXIT or PARTIAL_EXIT positions)
   */
  realizedPnl?: number;
}

export interface Trade {
  id: number;
  symbol: string;
  date: string;
  side: string;
  notes?: string;
  walletId: string;
  wallet?: Wallet;
}

export interface Wallet {
  id: string;
  name: string;
  type: string;
  status: string;
  description?: string;
  userId?: string;
  balance: number;
  currency: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreatePositionInput {
  tradeId: number;
  type: PositionType;
  quantity: number;
  price: number;
  date: string;
  notes?: string;
  /**
   * Optional: cost basis for this position
   */
  costBasis?: number;
  /**
   * Optional: realized P&L for this position
   */
  realizedPnl?: number;
}

export interface UpdatePositionInput {
  type?: PositionType;
  quantity?: number;
  price?: number;
  date?: string;
  notes?: string;
  status?: PositionStatus;
  /**
   * Optional: cost basis for this position
   */
  costBasis?: number;
  /**
   * Optional: realized P&L for this position
   */
  realizedPnl?: number;
}

export interface AverageCostBasisResult {
  averageCostBasis: number;
  totalQuantity: number;
  totalCost: number;
}

export interface PositionSuggestion {
  id: string;
  type: "quantity" | "price" | "type" | "stopLoss";
  currentValue: number | "ENTRY" | "EXIT" | "PARTIAL_EXIT" | "ADD_TO_POSITION";
  suggestedValue:
    | number
    | "ENTRY"
    | "EXIT"
    | "PARTIAL_EXIT"
    | "ADD_TO_POSITION";
  reason: string;
  impact: "low" | "medium" | "high";
}
